import React from "react";

/**
 * The video marker on a thumbnail: a bare white triangle with softened corners
 * and a drop shadow, no disc behind it. Corners are rounded by stroking the
 * path in its own fill colour, which also fattens it slightly, so the geometry
 * is drawn a touch inside the box to compensate.
 */
export function PlayGlyph({ size }: { size: number }) {
  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      data-testid="play-glyph"
      style={{ width: size, height: size, filter: "drop-shadow(0px 1px 4px rgba(0,0,0,0.35))" }}
      viewBox="0 0 24 24"
    >
      <path d="M7 4.5 L20 12 L7 19.5 Z" fill="white" stroke="white" strokeLinejoin="round" strokeWidth="2.5" />
    </svg>
  );
}
